import { CommApiInstance } from "Utils/CommApiInstance";


const TcktApi = async (
) => {
    return await CommApiInstance.post(`memb/tckt`,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data);
}

export default TcktApi;